import {
  Box,
  CircularProgress, Grid, Typography,
} from '@material-ui/core';

export default function TopCities({ data = [], loading, hasIos }) {
  const renderTopCities = () => {
    let top;
    if (!data.length) {
      return (
        <Box component="span" p={10}>
          <Typography variant='h6'>No Data</Typography>
        </Box>
      );
    }
    if (hasIos) {
      data.sort((a, b) => b.Stat.unique_clicks - a.Stat.unique_clicks);
    }
    return data.map((item, i) => {
      const stat = hasIos ? +item.Stat.unique_clicks : +item.Stat.conversions || +item.Stat.unique_clicks;
      if (!top) {
        top = stat;
      }
      const value = Math.round((stat / top) * 100);
      return (
        <Grid key={i} style={{ paddingBottom: 15 }} container direction="row" item md={12} justifyContent="flex-start" alignItems="center">
          <Grid style={{ paddingRight: 15 }} container direction="row" item md={4} justifyContent="flex-start" alignItems="center">
            <Typography style={{ fontSize: 16, fontWeight: 'bold' }}>{item.Region.name}</Typography>
          </Grid>
          <Grid container direction="row" item md={5} justifyContent="flex-start" alignItems="center">
            <div style={{
              width: `${value}%`, height: 10, backgroundColor: '#f9a119', borderRadius: 7, opacity: value / 100,
            }}
            />
          </Grid>
          <Grid container direction="row" item md={3} justifyContent="flex-end" alignItems="center">
            <Typography style={{ fontSize: 14, fontWeight: 'bold' }}>{stat}</Typography>
          </Grid>
        </Grid>
      );
    });
  };
  return loading ? (
    <Grid style={{ paddingBottom: 15 }} container direction="row" item md={12} justifyContent="center" alignItems="center">
      <CircularProgress />
    </Grid>
  ) : renderTopCities();
}
